export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12214.d6f63b3e.jpg";